// Pushes a conversion event to GTM's dataLayer. Intentionally silent on failure —
// a blocked/missing dataLayer (ad blockers, GTM not loaded yet, etc.) must never
// break the actual form submission flow it's reporting on.
export function trackEvent(eventName, extraData = {}) {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      ...extraData,
    });
  } catch (error) {
    console.error(`Failed to push dataLayer event "${eventName}":`, error);
  }
}
